export default __webpack_public_path__ + "static/media/gambrel.53892214.png";